
import { generateNumbers } from "@/utils/math";
export type PlayStatus = "play" | "pause" | "stop";
export const LENGTH = 15; // S
export const decreasingSequence = generateNumbers(LENGTH);

export const getDefaultSeriesData = () => {
  const res = {
    UIRx_VehSpd: [],
    UIRx_HDCDispVxTar: [],
    UIRx_VAFBrkFxTrgt: [],
    UIRx_DrvrReqTrgtFxBrk_Bch1: [],
  } as DomianControl.HDCSeriesData;
  return res;
};


export const optionseries1 = () => [
  {
    id: "UIRx_VehSpd",
    name: "实际车速",
    color: "#c10301",
  },
  {
    id: "UIRx_HDCDispVxTar",
    name: "目标车速",
    color: "#2E8B57",
  },
];

export const optionseries2 = () => [
  {
    id: "UIRx_VAFBrkFxTrgt",
    name: "HDC目标制动力",
    color: "#0372bf",
  },
  {
    id: "UIRx_DrvrReqTrgtFxBrk_Bch1",
    name: "驾驶员制动力请求",
    color: "#ffc101",
  },
 
];

const dataZoomOption: any = {
  // rangeMode: "percent",
  // backgroundColor: "#8e96a1",
  fillerColor: "#8e96a1",
  borderRadius: 5,
  moveHandleSize: 10,
  moveHandleStyle: {
    color: "#8e96a1",
  },
  brushStyle: {
    color: "#5aac5d",
    opacity: 0.7,
    borderWidth: 2,
    borderColor: "#5aac5d",
  },
  handleIcon:
    "path://M12 2C17.52 2 22 6.48 22 12S17.52 22 12 22 2 17.52 2 12 6.48 2 12 2zm0 20C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10z", // jshint ignore:line
  handleSize: 35,
  handleStyle: {
    color: "rgba(0,0,0,1)",
    borderColor: "#8e96a1",
    borderWidth: 0,
    backgroundColor: "#8e96a1",
    opacity: 0.7,
  },
  backgroundColor: "rgba(0,0,0,0.0)",
};

export const getDataZoom2 = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      show: false,
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      top: 60,
      bottom: 40,
      startValue: 0,
      endValue: 10000,
    },
  ];
  return dataZoom;
};

export const getDataZoom1 = () => {
  const dataZoom = [
    {
      id: "dataZoomX",
      type: "slider",
      xAxisIndex: [0],
      height: 20,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      bottom: 10,
      moveHandleSize: 0,
    },
    {
      id: "dataZoomY",
      type: "slider",
      yAxisIndex: [0],
      // height: 10,
      filterMode: "none",
      // right: 20,
      ...dataZoomOption,
      // handleSize: 40,
      moveHandleSize: 10,
      right: 20,
      width: 20,
      top: 60,
      bottom: 40,
      startValue: 0,
      endValue: 50,
    },
  ];
  return dataZoom;
};
